import * as React from 'react';
import isNil from 'lodash/isNil';

import { FormField } from 'components/form';
import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';

import { __t, applyTranslations } from 'utils/language';
import { isRequired } from 'utils/validators';
import { GENDER_OPTIONS } from 'utils/influencers';

import './profile-gender.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./profile-gender.i18n.json'));

import type {
  Data,
  InfluencerProfileForm,
  MixedSelectDropdownItem
} from 'types';

interface Props {
  profile: InfluencerProfileForm,
  onChange: (profile: Partial<InfluencerProfileForm>) => void
}

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'profile_gender';

const ProfileGender: React.FC<Props> = ({
  profile,
  onChange
}) => {
  const getItems = (): Array<MixedSelectDropdownItem> => (
    [...GENDER_OPTIONS].map(value => ({
      identifier: value,
      isDisabled: false,
      isSelected: profile.influencerGender === value,
      label: __t(`${COMMON_MSG_KEY}.gender.${value.toLowerCase()}`),
      value
    }))
  );

  const handleChange = (
    updatedItems: Array<MixedSelectDropdownItem>,
    data?: Data | null,
    selectedItem?: Partial<MixedSelectDropdownItem> | null
  ): void => {
    if (isNil(data)) {
      return;
    }

    const value = selectedItem?.identifier || updatedItems[0].identifier;

    onChange({
      [data.type]: value
    });
  };

  return (
    <div className="profile-gender">
      <FormField
        label={__t(`${MSG_KEY}.labels.gender`)}
        labelType="highlighted"
        direction="column"
        showRequiredMark
        showValidationIcon={false}
        className="profile-gender__field"
        validators={[
          isRequired(profile.influencerGender)
        ]}
      >
        <MixedSelectDropdown
          key={`profile-main-information-fields__gender--${profile.influencerGender}`}
          name="influencerGender"
          items={getItems()}
          withSelectedInList
          className="profile-gender__dropdown"
          controlClassName="profile-gender__dropdown-control"
          onItemsToggle={handleChange}
          data={{ type: 'influencerGender' }}
        />
      </FormField>
    </div>
  );
};

export default ProfileGender;
